import React, { useEffect, useState } from 'react';
import { Table, Tag, Space, message, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { adminAPI } from '../services/api';

type Student = {
  id: string;
  full_name: string;
  email: string;
  phone_number?: string;
  college?: string;
  is_premium: boolean;
  created_at: string;
};

const Students: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Student[]>([]);

  const load = async () => {
    setLoading(true);
    try {
      const res = await adminAPI.getUsers();
      setData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      message.error('Failed to load students');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <Table
      loading={loading}
      dataSource={data}
      rowKey="id"
      columns={[
        { title: 'Name', dataIndex: 'full_name' },
        { title: 'Email', dataIndex: 'email' },
        { title: 'Phone', dataIndex: 'phone_number' },
        { title: 'College', dataIndex: 'college' },
        {
          title: 'Plan',
          dataIndex: 'is_premium',
          render: (v: boolean) => (
            <Tag color={v ? 'gold' : 'blue'}>{v ? 'Premium' : 'Free'}</Tag>
          ),
        },
        { title: 'Joined', dataIndex: 'created_at' },
        {
          title: 'Actions',
          key: 'actions',
          width: 200,
          render: (_: unknown, record: Student) => (
            <Space>
              <Button
                type="primary"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => navigate(`/students/${record.id}`)}
              >
                View activity
              </Button>
            </Space>
          ),
        },
      ]}
    />
  );
};

export default Students;
